import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="engage--spotlight"
// Positions a highlight ring over the target element.
// clickOutside is dispatched to the parent tour controller.
export default class extends Controller {
  static targets = ["backdrop", "highlight"]
  static values = {
    targetSelector: String,
    flowId: String,
  }

  connect() {
    this.#position()
  }

  clickOutside(_event) {
    // Propagate to parent tour controller for dismiss handling
    this.element.dispatchEvent(
      new CustomEvent("engage:clickOutside", {
        bubbles: true,
        detail: { flowId: this.flowIdValue },
      }),
    )
  }

  // ── Private ──────────────────────────────────────────────────────────────

  #position() {
    const el = document.querySelector(this.targetSelectorValue)
    if (!el || !this.hasHighlightTarget) return

    const rect = el.getBoundingClientRect()
    const pad = 4

    Object.assign(this.highlightTarget.style, {
      display: "",
      top: `${rect.top - pad}px`,
      left: `${rect.left - pad}px`,
      width: `${rect.width + pad * 2}px`,
      height: `${rect.height + pad * 2}px`,
    })
  }
}
